import MonsterHeadImage from "../assets/monsterHeadImage.png";
export const activityContent = {
  monster: {
    goal: "Jump into Fortnite Zero Build Battle Royale. Rely on your shooting skills and clever hiding spots to take down opponents.",
    desc: "Every time you eliminate an opponent, you earn 2 points and your score on the leaderboard gets updated in the end of a match.",
    name: "Monster mind",
    image: MonsterHeadImage,
  },
};
